import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    cssVariables: true,
    palette: {
        mode: 'dark',
        primary: {
            main: '#c9a84c',
        },
        secondary: {
            main: '#9e9e9e',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#070b1c',
            paper: '#0f1530',
        },
        text: {
            primary: '#f0ede8',
            secondary: '#9e9e9e',
        },
    },
    typography: {
        fontFamily: '"Inter", sans-serif',
        h1: {
            fontFamily: '"Cormorant Garamond", serif',
            fontWeight: 300,
            letterSpacing: '0.05em',
        },
        h2: {
            fontFamily: '"Cormorant Garamond", serif',
            fontWeight: 300,
        },
        h3: {
            fontFamily: '"Cormorant Garamond", serif',
            fontWeight: 400,
        },
        h4: {
            fontFamily: '"Cormorant Garamond", serif',
            fontWeight: 400,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#070b1c',
                    backgroundImage: "url('/images/patterns/gothic_bg.svg')",
                    backgroundRepeat: 'repeat',
                    backgroundSize: '100px 100px',
                },
            },
        },
    },
});

export default theme;
